/**
 * @desc getRoleUserRelationByRoleCode
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.RoleUserRelationResponseDto>
>;
export function request(
  params: API.appCenter.appFacadeImpl.getRoleUserRelationByRoleCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/roleUserRelation/page/roleCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
